export function GetLastTenDaysToCurrent(limit) {
  const lastTenDays = [];
  var currentDate = new Date();

  // Loop through the previous 10 days and add them to the array
  for (let i = 0; i < limit; i++) {
    const previousDay = new Date(currentDate);
    previousDay.setDate(currentDate.getDate() - i);
    lastTenDays.push(previousDay);
  }

  // You can format the dates as needed
  const formattedDates = lastTenDays.map((date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  });

  return formattedDates;
}

export function formatDate(inputDate) {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  const date = new Date(inputDate);
  return date.toLocaleDateString("en-US", options).toString() == "Invalid Date"
    ? ""
    : date.toLocaleDateString("en-US", options);
}

export function formatDate2(inputDate) {
  if (inputDate == null) {
    return "";
  }

  // Parse the UTC date string directly
  const date = new Date(inputDate);

  // Format the date to Philippine Time (UTC+8)
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
    timeZone: "Asia/Manila",
  };

  return date.toLocaleString("en-US", options);
}

export function formatDateTime(inputDate) {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "Asia/Manila", // Ensures PHT is used
  };
  const date = new Date(inputDate);
  return isNaN(date)
    ? ""
    : new Intl.DateTimeFormat("en-US", options).format(date);
}

export function formatDateYYYYMMDD(date) {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
  const day = String(d.getDate()).padStart(2, "0"); // Ensure two-digit day
  return `${year}-${month}-${day}`;
}

export function formatTime(time) {
  if (!time) return "";

  let [hours, minutes] = time.split(":");
  hours = parseInt(hours, 10);
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;

  return `${hours}:${minutes} ${period}`;
}

export function addHoursToDate(hours) {
  let date = new Date(); // Current date/time
  date.setHours(date.getHours() + hours); // Add hours
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
}

export const getSixMonthsAgo = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 6);
  return date;
};

export const toUTCDateTimeString = (date, time = "00:00") => {
  const [hours, minutes] = time.split(":");

  // Create a new date to avoid mutating the original
  const newDate = new Date(date);

  // Set the time in local timezone
  newDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

  // **KEY FIX: Convert from Philippine Time (UTC+8) to UTC by subtracting 8 hours**
  const utcDate = new Date(newDate.getTime() - 8 * 60 * 60 * 1000);

  // Format the date components manually to avoid timezone conversion
  const year = utcDate.getFullYear();
  const month = String(utcDate.getMonth() + 1).padStart(2, "0");
  const day = String(utcDate.getDate()).padStart(2, "0");
  const hour = String(utcDate.getHours()).padStart(2, "0");
  const minute = String(utcDate.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hour}:${minute}:00.000+00:00`;
};
